import { render, staticRenderFns } from "./Userfeedback.vue?vue&type=template&id=35f9e1ae&scoped=true&"
import script from "./Userfeedback.vue?vue&type=script&lang=js&"
export * from "./Userfeedback.vue?vue&type=script&lang=js&"
import style0 from "./Userfeedback.vue?vue&type=style&index=0&id=35f9e1ae&scoped=true&lang=css&"
import style1 from "./Userfeedback.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9e1ae",
  null
  
)

export default component.exports